const light = "_light_1tncs_1";
const lightTheme = "_light-theme_1tncs_1";
const dark = "_dark_1tncs_1";
const darkTheme = "_dark-theme_1tncs_1";
const bold = "_bold_1tncs_10";
const italic = "_italic_1tncs_14";
const underline = "_underline_1tncs_18";
const strikethrough = "_strikethrough_1tncs_34";
const underlineStrikethrough = "_underlineStrikethrough_1tncs_38";
const subscript = "_subscript_1tncs_42";
const superscript = "_superscript_1tncs_47";
const code = "_code_1tncs_52";
const nestedListItem = "_nestedListItem_1tncs_59";
const listitem = "_listitem_1tncs_69";
const listItemChecked = "_listItemChecked_1tncs_73";
const listItemUnchecked = "_listItemUnchecked_1tncs_74";
const admonitionDanger = "_admonitionDanger_1tncs_151";
const admonitionInfo = "_admonitionInfo_1tncs_152";
const admonitionNote = "_admonitionNote_1tncs_153";
const admonitionTip = "_admonitionTip_1tncs_154";
const admonitionCaution = "_admonitionCaution_1tncs_155";
const mdxExpression = "_mdxExpression_1tncs_188";
const lexicalThemeStyles = {
  light,
  lightTheme,
  dark,
  darkTheme,
  bold,
  italic,
  underline,
  strikethrough,
  underlineStrikethrough,
  subscript,
  superscript,
  code,
  nestedListItem,
  listitem,
  listItemChecked,
  listItemUnchecked,
  admonitionDanger,
  admonitionInfo,
  admonitionNote,
  admonitionTip,
  admonitionCaution,
  mdxExpression
};
export {
  admonitionCaution,
  admonitionDanger,
  admonitionInfo,
  admonitionNote,
  admonitionTip,
  bold,
  code,
  dark,
  darkTheme,
  lexicalThemeStyles as default,
  italic,
  light,
  lightTheme,
  listItemChecked,
  listItemUnchecked,
  listitem,
  mdxExpression,
  nestedListItem,
  strikethrough,
  subscript,
  superscript,
  underline,
  underlineStrikethrough
};
